/**
 * Client Stories Block JavaScript
 */

(function() {
    'use strict';
    
    function initClientStories() {
        const blocks = document.querySelectorAll('.client-stories');
        
        blocks.forEach(block => {
            const wrapper = block.querySelector('.client-stories__wrapper.is-slider');
            if (!wrapper) return;

            const columns = wrapper.querySelector('.client-stories__columns');
            const prevBtn = wrapper.querySelector('.client-stories__nav--prev');
            const nextBtn = wrapper.querySelector('.client-stories__nav--next');
            if (!columns || !prevBtn || !nextBtn) return;

            function getScrollAmount() {
                const column = columns.querySelector('.client-stories__column');
                if (!column) return columns.offsetWidth;
                const gap = 20;
                return column.offsetWidth + gap;
            }

            function updateButtonStates() {
                const scrollLeft = columns.scrollLeft;
                const maxScroll = columns.scrollWidth - columns.clientWidth;
                prevBtn.disabled = scrollLeft <= 0;
                nextBtn.disabled = scrollLeft >= maxScroll - 1;
            }

            prevBtn.addEventListener('click', () => {
                columns.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', () => {
                columns.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            });

            columns.addEventListener('scroll', updateButtonStates);
            window.addEventListener('resize', updateButtonStates);
            updateButtonStates();
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initClientStories);
    } else {
        initClientStories();
    }
})();